import * as go from 'gojs';

interface GenericTooltipConfig {
  colors: {
    fill: string;
    stroke: string;
  };
}

const $ = go.GraphObject.make;

export const genericToolTip = (
  config: GenericTooltipConfig,
  textBindings: go.Binding[],
  toolTipBindings: go.Binding[] = [],
) =>
  $(
    'ToolTip',
    {
      'Border.fill': config.colors.fill,
      visible: true,
    },
    ...toolTipBindings,
    $(
      go.TextBlock,
      {
        margin: 2,
        stroke: config.colors.stroke,
      },
      ...textBindings,
    ),
  );
